import { useMutation } from 'react-query';

import { getReportExecSummary } from 'api/endPoints/getReportExecSummary';

interface UseMutationGetReportExecSummaryQueryParams {
    id: number;
}

export const useMutationGetReportExecSummary = () => {
    return useMutation<QueryResponse, QueryError, UseMutationGetReportExecSummaryQueryParams>({
        mutationFn: async (params) => {
            return getReportExecSummary(params);
        },
    });
};

export interface QueryResponse {
    id: number;
}
